import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { JamPadArtist, UserType } from "../DataModels.ts";

import { TextField, Box, Button, Autocomplete, Grid, Typography } from "@mui/material";
import { Verified } from "@mui/icons-material";

interface Props { 
  artists: JamPadArtist[], 
  addArtist: any, removeArtist: any
}
export const EventArtistSearch = ({ artists, addArtist, removeArtist } : Props) => {
    const artistResultLimit = 10;
    const searchDelay = 300; // in ms

    const [search, setSearch] = useState("");
    const [buff, setBuff] = useState("");
    const [matchingArtists, setMatchingArtists] = useState<JamPadArtist[]>([]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setBuff(search);
        }, searchDelay);
        return () => { clearTimeout(handler); };
    }, [search]);
    useEffect(() => {
        if (buff !== "") {
            searchForArtists();
        }
    }, [buff]);

    async function searchForArtists() {
        const { data, error } = await supabase.from("profiles")
            .select("id, username")
            .eq('type', UserType.Artist)
            .or(`username.ilike.%${search}%, display_name.ilike.%${search})%`)
            .limit(artistResultLimit);
        if(error) {
            console.error("Profile search failed: " + error.message);
        } else {
            const results = data.map((a) => {
                return { id: a.id, name: a.username } as JamPadArtist;
            });
            results.push({ id: null, name: search } as JamPadArtist);
            setMatchingArtists(results);
        }
    }

    return <Autocomplete fullWidth freeSolo filterOptions={(x) => x}
        value={search} noOptionsText="No results"
        options={matchingArtists} getOptionLabel={
            (option) => typeof option === 'string' ?  option : option.name 
        }
        onChange={(_, selected) => {
            if(selected) {
                addArtist(selected);
            }
            setMatchingArtists([]);
            setSearch("");
        }}
        onInputChange={(_, val) => { setSearch(val); }}
        renderInput={(params) => (
            <div>
                <TextField {...params} label="Event Artists" fullWidth />
                { artists.length > 0 && 
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center',
                        gap: '10px', padding: '10px 0' 
                    }}>
                        {artists.map((a) => {
                            return <Button sx={{ textTransform: 'none' }} 
                                variant={ a.id ? "contained" : "outlined" } onClick={() => {
                                if(window.confirm(`Remove ${a.name} from this event?`)) {
                                    removeArtist(a);
                                }
                            }}>{a.name}</Button>
                        })}
                    </div>
                }
            </div>
        )}
        renderOption={({ key, ...props }, artist) => (
            <li key={key} {...props}>
                <Grid sx={{ width: 'calc(100% - 44px)', wordWrap: 'break-word' }}>
                    <Box component="span" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <div>{artist.name}</div>
                        { artist.id !== null && 
                            <Verified style={{ color: 'blue' }} />
                        }
                    </Box>
                    { artist.id === null &&
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            <i>Your input, not linked to a Jampad profile</i>
                        </Typography>
                    }
                </Grid>
            </li>
        )}
    />
};
export default EventArtistSearch;